import axios from 'axios';

const getProductDetails = (productId) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/api/product/getProductDetails/${productId}`)
    .then(res => res)
    .catch(err => err);
};

export default getProductDetails;
